import React, {Component} from 'react'
import {Form, Select, Tag, notification, Empty, Spin} from 'antd'
import {getAllMcpServices, saveUserMcpServices} from "../../request";

export default class SysUserMcpServices extends Component {
    formRef = React.createRef();
    state = {
        allServices: [],
        loading: false
    }

    componentDidMount() {
        this.loadAllServices();
    }

    componentDidUpdate(prevProps) {
        if (this.props.userInfo.userId !== prevProps.userInfo.userId ||
            this.props.selectedServiceCodes !== prevProps.selectedServiceCodes) {
            this.resetForm();
        }
    }

    loadAllServices = () => {
        this.setState({loading: true});
        getAllMcpServices({}).then(res => {
            this.setState({
                allServices: res || [],
                loading: false
            });
        }).catch(() => {
            this.setState({loading: false});
        });
    }

    resetForm = () => {
        if (this.formRef.current) {
            this.formRef.current.setFieldsValue({serviceCodes: this.props.selectedServiceCodes || []});
        }
    }

    handleChange = (changedValues, allValues) => {
        const {userInfo} = this.props;
        saveUserMcpServices({
            userId: userInfo.userId,
            serviceCodes: (allValues.serviceCodes || []).join(',')
        }).then(() => {
            notification.success({
                message: '操作成功',
            });
            this.props.onReload && this.props.onReload();
        });
    }

    render() {
        const {allServices, loading} = this.state;
        const options = allServices.map(item => ({
            label: item.serviceName || item.serviceCode,
            value: item.serviceCode
        }));
        return (
            <Spin spinning={loading}>
                {
                    options.length > 0 ?
                        <Form
                            ref={this.formRef}
                            initialValues={{serviceCodes: this.props.selectedServiceCodes}}
                            onValuesChange={this.handleChange}
                        >
                            <Form.Item name="serviceCodes">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    style={{width: '100%'}}
                                    showSearch
                                    placeholder="请选择"
                                    options={options}
                                    filterOption={(input, option) =>
                                        (((option && option.label) || '') + ' ' + ((option && option.value) || '')).toLowerCase().includes(input.toLowerCase())
                                    }
                                    tagRender={(props) => {
                                        const {label, closable, onClose} = props;
                                        return (
                                            <Tag style={{margin: 5}} color={'purple'} closable={closable}
                                                 onClose={onClose}>{label}</Tag>
                                        )
                                    }}
                                />
                            </Form.Item>
                        </Form> :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>
                }
            </Spin>
        )
    }
}
